export default function ApiError({message}){
    return <>
        <div className="p-2 text-center ">
            <p className="text-danger fw-bold">{message}</p>
            <img src="/myicons/load-error.png" alt={`error`} className="img-fluid" width="100" height="100" />
        </div>
    </>;
}